module.exports = __webpack_public_path__ + "0544dc3572f965bea376e26ee5270d94.pdf";